import { store } from 'v3/data/store';
import { cancellationNavigationSlice } from 'v3/data/store/cancellationNavigation';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';

export const setCurrentCancellationState = (cancellationState: CancellationNavigationEnum | null) => {
  store.dispatch(cancellationNavigationSlice.actions.setCancellationStep(cancellationState));
};

export const setCancelationModalOpen = (open: boolean) => {
  store.dispatch(cancellationNavigationSlice.actions.setDialogState(open));
};

export const setCancelationErrorModalOpen = (open: boolean) => {
  store.dispatch(cancellationNavigationSlice.actions.setErrorDialogState(open));
};

export const setClearCancellationState = () => {
  store.dispatch(cancellationNavigationSlice.actions.setClearCancellationState());
};

export const setRefundConflictModalOpen = (open: boolean) => {
  store.dispatch(cancellationNavigationSlice.actions.setRefundConflictDialogState(open));
};
